import { castArray, uniq } from 'lodash'

const getTags = (tags) => {
  return uniq(castArray(tags))
    .filter(Boolean)
    .map((id) => {
      const [type, name] = id.split(':')
      return {
        id,
        name,
        type
      }
    })
}

export { getTags }
